import {OverlayRef} from '@angular/cdk/overlay';
import {Subject} from 'rxjs';

export interface OverlayCloseEvent<R> {
  type: 'backdropClick' | 'close';
  data: R;
}

export class ModalOverlayRef<R = any, T = any> {
  afterClosed$ = new Subject<OverlayCloseEvent<R>>();

  constructor(private overlayRef: OverlayRef) {

    overlayRef.backdropClick().subscribe(() => this._close('backdropClick', null));
  }

  close(): void {
    this.overlayRef.dispose();
  }

  closeD(data?: R) {
    this._close('close', data);
  }

  private _close(type: 'backdropClick' | 'close', data: R) {
    this.overlayRef.dispose();
    this.afterClosed$.next({
      type,
      data
    });

    this.afterClosed$.complete();
  }
}
